<template>
  <filter-component class="scrollable" :filter-types="filteredFilterTypes" :filter-change="filterChanged" :filter-list-change="filterListChanged"
                    :filter-clear="filterClear" :disabled="loading" :list-sources="listSources" :my-filter-change="myFiltersChanged" from="students" />
</template>

<script>
  import FilterComponent from './FilterComponent'
  import { mapActions, mapState, mapGetters } from 'vuex'
  import {
    CLEAR_STUDENTS_LIST_FILTERS_ACTION,
    STUDENTS_LIST_CHANGE_FILTER,
    STUDENTS_LIST_CHANGE_LIST_FILTER,
    GET_COURSES_FOR_STUDENTS, GET_SAVED_FILTERS_FOR_STAFF
  } from '../../store/action-types'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'

  export default {
    components: {FilterComponent},
    name: 'student-filter-container',
    props: [],
    mixins: [],
    methods: {
      ...mapActions({
        filterChanged: STUDENTS_LIST_CHANGE_FILTER,
        filterListChanged: STUDENTS_LIST_CHANGE_LIST_FILTER,
        myFiltersChanged: GET_SAVED_FILTERS_FOR_STAFF,
        filterClear: CLEAR_STUDENTS_LIST_FILTERS_ACTION
      })
    },
    computed: {
      ...mapState({
        filterTypes: state => state.students.filterFields,
        loading: state => state.students.loading,
        courses: state => state.students.filterFields.courseIds.courses,
        listSourcesState: state => state.students.listSources,
        moduleStudent: state => state.profile.module.student,
        functionMyStudent: state => state.students.functions.myStudents,
        optionEnableAverageEngagement: state => state.students.options.enable.averageEngagement
      }),
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      listSources () {
        return this.listSourcesState
      },
      filteredFilterTypes () {
        if (!this.flagDisplayAverageEngagementRating) {
          let obj = {}
          Object.keys(this.filterTypes).forEach(el => {
            if (el !== 'averageEngagementRatings') {
              obj[el] = this.filterTypes[el]
            }
          })
          return obj
        }
        return this.filterTypes
      },
      flagDisplayAverageEngagementRating () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableAverageEngagement)
      }
    },
    mounted () {
      if (this.courses.length === 0) {
        this.$store.dispatch(GET_COURSES_FOR_STUDENTS)
      }
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/StudentFilterContainer.vue